import { get, getBlob } from '../client';

export const dashboardApi = {
  getCounts: () => get('/dashboard'),
  villageSummary: (params = {}) => get('/dashboard/village-summary', { params }),
  exportVillageSummary: (params = {}) =>
    getBlob('/dashboard/village-summary/export', { params }),
  buSiteSummary: (params = {}) => get('/dashboard/bu-site-summary', { params }),
  exportBuSiteSummary: (params = {}) =>
    getBlob('/dashboard/bu-site-summary/export', { params }),
};
